import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c384d632"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type"]
const _hoisted_2 = {
  class: "button__icon",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "button__text"
}

import { getIconComponent } from '../icons/utils';

type ButtonType = "button" | "submit" | "reset";

interface Props {
	icon: string;
	onClick: Function;
	text?: string;
	type?: ButtonType;
	index?: number;
	isActive?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonPrimitive',
  props: {
    icon: {},
    onClick: {},
    text: { default: "" },
    type: { default: "button" },
    index: {},
    isActive: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: props.type,
    class: _normalizeClass(['button', props.isActive ? 'button--active' : '']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.onClick && props.onClick(...args)))
  }, [
    _createElementVNode("span", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIconComponent)(props.icon))))
    ]),
    (props.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.text), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})